import type { TransitPathLineStyle } from "./routeLine.types";

/** Dimmed line opacity for traversed route segments. */
export const TRANSIT_PATH_LINE_OPACITY_DIMMED = 0.6;

/** Full line opacity for active segments. */
export const TRANSIT_PATH_LINE_OPACITY_ACTIVE = 1;

/** Line width for traversed (dimmed) route segments. */
export const TRANSIT_PATH_LINE_WIDTH_DIMMED = 3;

/** Line width for active route segments. */
export const TRANSIT_PATH_LINE_WIDTH_ACTIVE = 5;

/** Dash pattern for traversed route polylines. */
export const TRANSIT_PATH_LINE_DASHARRAY_DIMMED: [number, number] = [ 1.5, 1.5 ];

/** Default paint style for active current and remaining segments. */
export const TRANSIT_PATH_LINE_STYLE_ACTIVE: TransitPathLineStyle = {
    "lineOpacity": TRANSIT_PATH_LINE_OPACITY_ACTIVE,
    "lineWidth":   TRANSIT_PATH_LINE_WIDTH_ACTIVE,
};

/** Paint style for traversed (past) route segments. */
export const TRANSIT_PATH_LINE_STYLE_TRAVERSED: TransitPathLineStyle = {
    "lineOpacity":   TRANSIT_PATH_LINE_OPACITY_DIMMED,
    "lineWidth":     TRANSIT_PATH_LINE_WIDTH_DIMMED,
    "lineDasharray": TRANSIT_PATH_LINE_DASHARRAY_DIMMED,
};

/** Alias for itinerary leg dimming (same paint as traversed realtime segments). */
export const TRANSIT_PATH_LINE_STYLE_DIMMED = TRANSIT_PATH_LINE_STYLE_TRAVERSED;
